"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
function Divider({ className = '', borderColor = 'border-silver-30', }) {
    return ((0, jsx_runtime_1.jsx)("hr", { className: (0, classnames_1.default)('my-9', {
            [borderColor]: borderColor,
        }, className) }));
}
exports.Divider = Divider;
//# sourceMappingURL=Divider.js.map